import { render, staticRenderFns } from "./processDifferControlApproval.vue?vue&type=template&id=c684708e&scoped=true"
import script from "./processDifferControlApproval.vue?vue&type=script&lang=js"
export * from "./processDifferControlApproval.vue?vue&type=script&lang=js"
import style0 from "./processDifferControlApproval.vue?vue&type=style&index=0&id=c684708e&prod&lang=scss&scoped=true"
import style1 from "./processDifferControlApproval.vue?vue&type=style&index=1&id=c684708e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c684708e",
  null
  
)

export default component.exports